import FallbackComponent from "client/FallbackComponent";
import { Heading, Text } from "client/ui-components";
import UserPageLayout from "client/ui-components/Layouts/UserPage";
import useQueryString from "client/utils/useQueryString";
import React from "react";
import UnsubscribeCTA from "./components/UnsubscribeCTA";
import { Content, Wrapper } from "./styles";

export default function EmailPreferences() {
  const query = useQueryString();
  const user = query.get("user");
  if (!user) return <FallbackComponent />;
  return (
    <UserPageLayout>
      <Wrapper className="px-35">
        <Content>
          <Heading variant="h2" as="h1" textAlign="center" className="mb-25">
            Unsubscribe from marketing emails?
          </Heading>
          <Text textAlign="center" fontWeight={400}>
            You’ll stop receiving marketing messages at{" "}
            <Text as="span" fontWeight={700}>
              {user}
            </Text>{" "}
            from Boomerang, but we’ll still email you about important updates on your claim.
          </Text>
          <UnsubscribeCTA user={user} />
        </Content>
      </Wrapper>
    </UserPageLayout>
  );
}
